import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const salesPhotosSelector = createSelector(
  (state: RootState) => state.photo.salesPhotos,
  (photoOrders) => photoOrders,
);

export const photoOrdersSelector = createSelector(
  (state: RootState) => state.photo.photoOrders,
  (photoOrders) => photoOrders,
);

export const photoItemListSelector = createSelector(
  [
    (state: RootState) => state.photo.photoItemList,
    (state: RootState) => state.payment.apiSettings,
  ],
  (photoItemList, apiSettings) => {
    // 設定されている場合のみdownload販売可能とする
    if (apiSettings) {
      const keys = Object.keys(apiSettings);
      if (keys.length > 0) {
        const settings = apiSettings[keys[0]];
        if (settings.isEnableDownloadSales
          && settings.isEnableDownloadSales) {
          return photoItemList;
        }
      }
    }
    return photoItemList?.filter((v) => v.photoItemId !== 'download');
  },
);

export const childFacilitySelector = createSelector(
  (state: RootState) => ({
    facilityList: state.childApply.facilityList,
    childId: state.child.childId,
  }),
  ({ facilityList, childId }) => {
    const facility = facilityList.find((v) => v.data.childId === childId);
    return facility?.data.facilityId || '';
  },
);

export const nurseryIdSelector = createSelector(
  (state: RootState) => ({
    facilityList: state.childApply.facilityList,
    childId: state.child.childId,
  }),
  ({ facilityList, childId }) => {
    const facility = facilityList.find((v) => v.data.childId === childId);
    return facility?.data.facilityId || '';
  },
);

export const apiSettingsSelector = createSelector(
  (state: RootState) => state.payment.apiSettings,
  (apiSettings) => apiSettings,
);
